import { Switch } from 'antd'
import { ListResponseMandatoryFieldBean, MandatoryFieldBean } from 'common/api/api.ts'
import { mandatoryFieldApi } from 'common/api/entitiesApi.tsx'
import { ActiveStatusSelector } from 'common/components/dictionary/ActiveStatusSelector.tsx'
import { ListCard } from 'common/components/ListCard.tsx'
import { SearchInput } from 'common/components/SearchInput.tsx'
import { ListFilters, useAppContext } from 'common/context/AppContext.tsx'
import { initListFilters, useListFilters } from 'common/util/useListFilters.ts'
import { apiCall } from 'common/util/Util.tsx'
import { useState } from 'react'
import { COLUMN_ID_WIDTH } from 'common/util/constants.ts'

const MandatoryFieldList = () => {
  const appContext = useAppContext()
  const [filters, setFilters] = useState<ListFilters>(initListFilters())
  const { setFilter } = useListFilters(setFilters)
  const [loading, setLoading] = useState(false)
  const [listData, setListData] = useState<ListResponseMandatoryFieldBean>()

  const loadData = () => {
    const size = filters.pageSize ?? 10
    const page = filters.page ?? 1

    apiCall(
      setLoading,
      appContext,
      () =>
        mandatoryFieldApi.mandatoryFields(filters.sort?.name, filters.sort?.direction, filters.name, filters.active, {
          query: { size, page },
        }),
      (data) => setListData(data),
    )
  }

  const toggleRequired = (id: number, checked: boolean) => {
    apiCall(
      setLoading,
      appContext,
      () => mandatoryFieldApi.mandatoryFieldToggleRequired(id),
      () =>
        setListData((prev) =>
          prev
            ? {
                ...prev,
                data: prev.data?.map((item) =>
                  item.data?.id === id ? { ...item, data: { ...item.data, required: checked } } : item,
                ),
              }
            : prev,
        ),
    )
  }

  return (
    <ListCard<MandatoryFieldBean>
      loading={loading}
      title="Mandatory fields"
      // createName="Mandatory Field"
      // createRoute="/mandatory/create"
      filters={filters}
      setFilters={setFilters}
      listData={listData as any}
      loadData={loadData}
      columns={[
        {
          title: 'ID',
          dataIndex: 'id',
          width: COLUMN_ID_WIDTH,
        },
        {
          title: 'Name',
          dataIndex: 'name',
          className: 'list-table-name',
          sorter: true,
          ellipsis: true,
          render: (text: string) => <span style={{ color: '#5888CF', minWidth: 100 }}>{text}</span>,
        },
        {
          title: 'Description',
          dataIndex: 'description',
          ellipsis: true,
        },
        {
          title: 'Required',
          dataIndex: 'required',
          render: (val, record: MandatoryFieldBean) => (
            <Switch
              size="small"
              checked={record.required}
              onChange={(checked) => record.id && toggleRequired(record.id, checked)}
            />
          ),
          width: 80,
        },
      ]}
    >
      <SearchInput value={filters.name} onChange={(value) => setFilter('name', value)} />
      <ActiveStatusSelector
        style={{ minWidth: '140px' }}
        placeholder="Filter by Required"
        value={filters.active}
        onChange={(value) => setFilter('active', value)}
      />
    </ListCard>
  )
}

export default MandatoryFieldList
